<template>
  <page-header title="Вакансии"/>
  <div class="vacancy public-container public-container-mobile">
    <div id="main" class="vacancy-grid">
      <div>
        <h2
          class="vz-text-align-left"
          v-html="content.blocks?.main.title"
        />
        <div class="vacancy-description">
          {{ content.blocks?.main.description }}
        </div>
        <div class="flex vacancy-buttons">
          <vz-button
            large
            :href="hhLink"
            target="_blank"
            variant="primary"
            icon-name="arrow-right"
            :icon-size="22"
            icon-right
          >
            на hh.ru
          </vz-button>
        </div>
      </div>
      <div class="vacancy-background"/>
    </div>

    <div class="vacancy-requirements">
      <h2 class="vz-text-align-left">{{ content.blocks?.main.require }}</h2>
      <div v-for="item of rulesItems" class="vacancy-requirements-item">
        <vz-icon
          :url="item.icon"
          variant="primary"
          no-masked-icon
        />
        <span v-html="item.text"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from "~/components/public/page-header.vue"
import VzButton from "~/components/ui-kit/vz-button.vue"
import { getPageContent } from "~/api/content"
import { hhLink, avitoLink } from "~/api/constant-urls"

const content = await getPageContent('/vacancy')

const rulesItems = [
  {
    icon: '/svg/wrapping-box.svg',
    text: content.blocks?.main.loader,
  },
  {
    icon: '/svg/box-transportation.svg',
    text: content.blocks?.main.loaderDrivers,
  },
  {
    icon: '/svg/stock.svg',
    text: content.blocks?.main.stockman,
  },
  {
    icon: '/svg/vz-suitcase.svg',
    text: content.blocks?.main.specialties,
  }
]
</script>

<style scoped lang="scss">
.vacancy {
  margin-top: 70px;
  margin-bottom: 110px;

  &-grid {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: calc(50% - 5px) 1fr;
  }

  &-background {
    min-height: 340px;
    background-image: url("/images/pages/vacancy/vacancy1920.png");
  }

  &-description {
    margin-bottom: 20px;
  }

  &-requirements {
    margin-top: -24px;

    &-item {
      display: flex;
      gap: 10px;
      align-items: center;
      margin-top: 14px;
      font-weight: bold;
    }
  }

  &-buttons {
    gap: 20px;

    > a {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      width: 228px;
    }
  }

  @media screen and (max-width: $pub-md) {
    &-requirements {
      margin-top: 0;
    }

    &-background {
      min-height: 320px;
      background-image: url("/images/pages/vacancy/vacancy1239.png");
    }
  }

  @media screen and (max-width: $pub-sm) {
    margin-top: 50px;
    margin-bottom: 70px;

    &-grid {
      grid-gap: 10px;
    }

    &-requirements {
      margin-top: 40px;
    }

    &-background {
      min-height: 290px;
      background-image: url("/images/pages/vacancy/vacancy768.png");
    }

    &-buttons {
      gap: 10px;

      > a {
        width: 164px;
        gap: 0;
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-grid {
      gap: 33px;
      grid-template-columns: 1fr;
    }

    &-background {
      min-height: 290px;
      background-image: url("/images/pages/vacancy/vacancy320.png");
      background-position: center;
    }

    &-buttons {
      gap: 20px;
      flex-direction: column;

      > a {
        width: 100%;
        gap: 6px;
      }
    }
  }
}

</style>
